<template>
  <div class="w-full flex flex-col justify-center items-center gap-10">
    <Wrapper class="max-w-2xl">
      <h2 class="mb-2 text-2xl md:text-3xl text-blue-dark">
        <b>Proceso de resolución agiliza</b>
      </h2>
      <div class="border border-blue-dark mb-2" />

      <div class="text-left mt-5 px-4">
        <a-timeline>
          <a-timeline-item v-if="context_complaint !== ''">
            <div v-html="context_complaint"></div>
          </a-timeline-item>

          <template v-if="isResponseRequired">
            <a-timeline-item class="pb-0">
              Para continuar con el trámite, es necesario que revise los
              <span
                class="text-blue-600 cursor-pointer hover:underline font-bold"
                @click="showModalTermsConditions"
              >
                términos y condiciones
              </span>
              y confirme su vinculación al proceso de resolución agiliza
              respondiendo con <b>Sí</b> o <b>No</b>.
              <form @submit.prevent="checkAnswers" class="w-full mb-2">
                <div class="w-full mb-5">
                  <div class="w-full">
                    <BaseRadio
                      name="questionAnswer"
                      id="questionAnswer"
                      :radioOptions="optionsYN"
                      v-model="questionAnswer"
                      required="true"
                    />
                  </div>
                </div>
                <p
                  v-if="feedback && feedback !== ''"
                  class="text-sm text-center text-red-500 mt-8"
                  aria-live="polite"
                >
                  {{ feedback }}
                </p>

                <div class="form-group w-full mt-9 text-left flex flex-col">
                  <div class="flex flex-col gap-3">
                    <a-button
                      id="register-button"
                      type="primary"
                      shape="round"
                      html-type="submit"
                      :block="true"
                      :loading="loading"
                      >ACEPTAR</a-button
                    >
                    <a-button
                      type="primary"
                      shape="round"
                      :block="true"
                      ghost
                      @click="returnHome"
                      >VOLVER</a-button
                    >
                  </div>
                </div>
              </form>
            </a-timeline-item>
          </template>
          <template v-if="isResponseRequired === false">
            <a-timeline-item class="pb-0">
              <div v-html="context_already_given"></div>
              <div class="form-group w-full mt-9 text-left flex flex-col">
                <div class="flex flex-col gap-3">
                  <a-button
                    type="primary"
                    shape="round"
                    :block="true"
                    ghost
                    @click="returnHome"
                    >VOLVER</a-button
                  >
                </div>
              </div>
            </a-timeline-item>
          </template>
        </a-timeline>
      </div>
    </Wrapper>
    <Modal v-if="viewModal" size="md">
      <div class="text-justify">
        <h3 class="text-blue-700 text-2xl mt-2 mb-4">
          Proceso de resolución agiliza
        </h3>
        <p class="mt-4">
          {{ textModal }}
        </p>
      </div>
      <div class="text-center">
        <button
          @click="returnHome"
          class="mt-4 py-2 px-4 bg-blue-500 text-white rounded-lg"
        >
          ACEPTAR
        </button>
      </div>
    </Modal>
    <Modal v-if="viewModalTermsConditions" size="md">
      <h3 class="text-blue-700 text-2xl mt-2 mb-4 text-center">
        Términos y condiciones
      </h3>
      <div class="text-left mt-5 px-4">
        <a-timeline>
          <a-timeline-item>
            <div>
              <p>
                La información del Consumidor Financiero es indispensable para
                radicar la inconformidad.
              </p>
            </div>
          </a-timeline-item>
          <a-timeline-item>
            <div>
              <p>
                En caso de que su inconformidad esté relacionada con un reporte
                de operadores o centrales de información, es necesario que haya
                presentado una queja ante la entidad vigilada o su Defensor del
                Consumidor Financiero.
              </p>
            </div>
          </a-timeline-item>
          <a-timeline-item>
            <div>
              <p>
                De conformidad con lo dispuesto en la Ley 1581 de 2012, el
                Decreto 1377 de 2013 y el Decreto 1074 de 2015, autorizo a la
                Superintendencia Financiera de Colombia (SFC) a realizar el
                tratamiento de los datos personales y/o sensibles necesario para
                el ejercicio de sus facultades, de conformidad con lo
                establecido en la Política de Tratamiento de datos de la SFC
                disponible en el siguiente
                <a
                  class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  target="_blank"
                  rel="noopener"
                  href="https://www.superfinanciera.gov.co/publicaciones/10106783/nuestra-entidadacerca-de-la-sfcpoliticas-de-la-entidadpoliticas-web-10106783/"
                  >link</a
                >.
              </p>
            </div>
          </a-timeline-item>
          <a-timeline-item>
            <div>
              <p>
                El texto completo de la autorización se encuentra disponible en
                el siguiente
                <a
                  aria-label="Enlace para descargar la autorización de tratamiento de datos personales"
                  href="https://www.superfinanciera.gov.co/loader.php?lServicio=Tools2&lTipo=descargas&lFuncion=descargar&idFile=1070896"
                  class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  >link</a
                >.
              </p>
            </div>
          </a-timeline-item>
        </a-timeline>
      </div>
      <div class="text-center">
        <button
          @click="closeModalTermsConditions"
          class="mt-2 py-2 px-4 border-2 border-blue-500 text-blue-500 hover:bg-blue-50 rounded-lg transition duration-200"
        >
          VOLVER
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ErrorMessaje from "@/core/error/error_messaje";
export default {
  async created() {
    this.loading = true;
    const { data, error } = await this.$api.getComplaintById(
      this.$route.params.complaint_id
    );
    this.loading = false;
    if (error) {
      this.showToast("error", "Error recuperando información de la queja");
      return;
    }

    if (data) {
      this.complaint.complaint_code = data.codigo_queja;
      this.complaint.company_name = data.entidad_cod;
      this.complaint.reason_name = data.macro_motivo_cod;

      const fecha = new Date(data.fecha_creacion);
      const opciones = { day: "numeric", month: "long", year: "numeric" };
      this.complaint.create_date = fecha.toLocaleDateString("es-ES", opciones);

      this.context_complaint = `La queja presentada en contra de <b>${this.complaint.company_name}</b>, 
      por el motivo <b>${this.complaint.reason_name}</b>, fue radicada el <b>${this.complaint.create_date}</b>, 
      bajo el radicado <b>${this.complaint.complaint_code}</b>. Esta ha sido sometida a un proceso de evaluación,
      mediante el cual la Superintendencia ha determinado que cumple con los criterios para ser tramitada a través 
      del proceso Agiliza, un mecanismo que facilita una gestión directa y acelerada entre el consumidor financiero 
      y la entidad vigilada.`;

      this.isResponseRequired =
        data.acepta_queja_agiliza === null ? true : false;
      if (!this.isResponseRequired) {
        this.responseText = data.acepta_queja_agiliza ? "Sí" : "No";
        this.context_already_given = `Ya se registró una respuesta respecto a la vinculación al proceso de resolución Agiliza. La respuesta registrada fue: <b>${this.responseText}</b>.`;
      }
    }
  },
  data() {
    return {
      context_already_given: "",
      context_complaint: "",
      complaint: {
        complaint_code: "",
        company_name: "",
        create_date: "",
        reason_name: "",
      },
      disableButton: false,
      isResponseRequired: false,
      feedback: "",
      loading: false,
      optionsYN: [
        { id: 1, name: "Sí" },
        { id: 2, name: "No" },
      ],
      textModal: "",
      questionAnswer: "",
      viewModal: false,
      viewModalTermsConditions: false,
    };
  },
  methods: {
    async checkAnswers() {
      this.loading = true;
      this.disableButton = true;

      if (this.questionAnswer === "") {
        this.feedback =
          "Debe proporcionar una respuesta a la pregunta formulada.";
        this.loading = false;
        this.disableButton = false;
        return;
      }

      const questionAnswerBool = this.questionAnswer == 1 ? true : false;

      let form = {
        acceptation: questionAnswerBool,
      };

      let { error, data } = await this.$api.acceptRejectComplaintAgiliza(
        form,
        this.complaint.complaint_code
      );

      if (error) {
        this.loading = false;
        this.disableButton = false;
        this.showToast("error", ErrorMessaje.generalError);
        return;
      }
      if (data) {
        this.loading = false;
        this.disableButton = false;

        if (questionAnswerBool) {
          this.textModal = `Se ha recibido y guardado exitosamente la confirmación para vincularse al proceso de resolución Agiliza. 
          El trámite con radicado ${this.complaint.complaint_code} continuará su curso a través de este mecanismo.`;
        } else {
          this.textModal = `Se ha recibido y guardado exitosamente la respuesta de NO vincularse al proceso de resolución Agiliza.`;
        }

        this.viewModal = true;
      }
    },
    returnHome() {
      this.$router.push("/customer/complaint/tracking").catch(() => {});
    },
    showModalTermsConditions() {
      this.viewModalTermsConditions = true;
    },
    closeModalTermsConditions() {
      this.viewModalTermsConditions = false;
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
  },

  watch: {
    questionAnswer() {
      this.feedback = "";
    },
    questionTwo() {
      this.feedback = "";
    },
  },
};
</script>
